import { ComponentDataSourceService } from '../../component-data-source.service';
import { DataSourceFunction } from '../../component-data-source.service';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { fetchParticipationCanCancel$ } from './event-participation-register-open.utils';

const LOG_PREFIX = '[event_visibility_ds]';

/**
 * Visibility data source for the event participate form.
 * Returns { visible: boolean } from backend GET /events/:guid/participation/can-cancel.
 * Visible only when: org allows unregister for this event type, user is already participating,
 * and event starts more than N days before start (per-type org setting). Used with visibilityDataSource on the cancel-participation page.
 */
export function event_allow_cancel_24h(service: ComponentDataSourceService): DataSourceFunction {
  return {
    name: 'event_allow_cancel_24h',
    description: 'Whether the current user can cancel participation (org setting + already participating + >24h before start). For visibilityDataSource.',
    execute: (_params?: LoadDataParams): Observable<{ visible: boolean }> => {
      return fetchParticipationCanCancel$(service).pipe(
        map((visible) => {
          return { visible };
        })
      );
    }
  };
}
